import { PageHeaderModule } from 'utils/i18n/TModules';

// Translation Keys And Paths
export const BreadcrumbsKey = `Breadcrumbs`;
export const TBreadcrumbs = `${PageHeaderModule}:${BreadcrumbsKey}`;
